import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { TabPanel, Tabs } from '@components/tabs';
import { tabs } from '@pages/QuoteDetails/sidebarItems/underwriting/Underwriting.constants';
import { UnderwritingActivityPanel } from '@pages/UnderwriterToolkit/tab-content/UnderwritingActivityPanel';
import { UnderwritingIssuesPanel } from './UnderwritingIssuesPanel/UnderwritingIssuesPanel';

export const UnderwritingRulesAndIssuesTab = () => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const queryString = searchParams.get('sidebarTab');
    const tab = tabs.find((t) => t.tabSearchParam === queryString);
    if (tab) {
      setTabValue(tab.value);
    }
  }, [searchParams]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('sidebarTab', tabs[newValue].tabSearchParam);
    setSearchParams(newParams);
  };

  return (
    <Box
      sx={{
        px: 2,
        height: '100%', // Take full available height
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <Tabs
        type='mini'
        disableRipple
        value={tabValue}
        onChange={handleChange}
        aria-label='Underwriting Tabs'
        tabOptions={tabs}
      />

      <Box
        sx={{
          flex: 1,
          minHeight: 0, // Allow content to shrink
          overflow: 'auto', // Enable scrolling for content
        }}
      >
        <TabPanel selectedTab={tabValue} value={tabs[0].value}>
          <UnderwritingIssuesPanel />
        </TabPanel>
        <TabPanel selectedTab={tabValue} value={tabs[1].value}>
          <UnderwritingActivityPanel />
        </TabPanel>
      </Box>
    </Box>
  );
};
